//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular from 'angular';

import template from '@streams-drawer/streams-drawer-standard-setup/streams-drawer-standard-setup.html';
import '@streams-drawer/streams-drawer-standard-setup/streams-drawer-standard-setup.less';

angular.module('curalate').component('streamsDrawerStandardSetup', {
  bindings: {
    onOpenNewStreamModal: '&',
    streamSuggestions: '<',
    shouldNotAllowUgcStreams: '<',
    isGraphApiConnected: '<',
  },
  template,
});
